<template>
    <common-body>
        <project-panels />
    </common-body>
</template>

<script>
import CommonBody from '../components/CommonBody.vue';
import ProjectPanels from '../components/projects/ProjectPanels.vue';
export default {
    components: {
        CommonBody,
        ProjectPanels
    }
}
</script>